/**
 * Rewrites legacy Brandfetch URLs that use the `transparent` fallback (which returns a
 * transparent placeholder PNG when no logo exists) to the `404` fallback so missing
 * logos surface as HTTP errors and the avatar can fall back to the building icon.
 *
 * TODO: remove once the Scout Agent index is re-built with the new URL format from BE.
 */
export function normalizeLogoUrl(url: string | null | undefined): string | null | undefined {
  if (!url) return url;
  if (!url.includes("/fallback/transparent")) return url;

  return url.replace("/fallback/transparent", "/fallback/404");
}
